import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { autoDetectLocale } from "./i18n";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";

createApp(App).use(router).mount("#app");

// Detecta el país por IP y ajusta el idioma (no bloquea el render)
autoDetectLocale();
